var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("admin-offer-expandable-panel"),
      _vm.data !== null
        ? _c(
            "order-details-for-order-item",
            { attrs: { data: _vm.data } },
            [
              _c(
                "v-tooltip",
                {
                  attrs: { bottom: "" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function(ref) {
                          var on = ref.on
                          return [
                            _c(
                              "v-btn",
                              _vm._g(
                                {
                                  staticClass: "mx-0",
                                  attrs: {
                                    to:
                                      "/admin/travel-service/edit/" +
                                      _vm.data.id,
                                    icon: "",
                                    small: ""
                                  }
                                },
                                on
                              ),
                              [
                                _c("v-icon", { attrs: { small: "" } }, [
                                  _vm._v("fa-file-invoice")
                                ])
                              ],
                              1
                            )
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    676312070
                  )
                },
                [_vm._v(" " + _vm._s(_vm.$t("travelService.goToOrder")) + " ")]
              )
            ],
            1
          )
        : _vm._e(),
      _c("order-item-parameters", {
        attrs: { type: _vm.type, "order-item": _vm.data.orderItem }
      }),
      !_vm.$store.state.AdminTravelService.isOfferReadonly
        ? _c(
            "v-row",
            { staticClass: "mb-2" },
            [
              _c(
                "v-col",
                { attrs: { cols: "10" } },
                [
                  _c(
                    "v-alert",
                    { attrs: { color: "error darken-4", outlined: "" } },
                    [
                      _vm._v(
                        " Jeśli parametry zapytania nie pozwalają na wycenę możesz zadać dodatkowe pytanie zamawiającemu. Aby to zrobić skorzystaj z przycisku wiadomości po prawej stronie. "
                      ),
                      _c("span", { staticClass: "font-weight-bold" }, [
                        _vm._v(
                          "Funkcjonalność ta powinna być wykorzystywana jedynie w przypadku gdy nie da się przygotować oferty."
                        )
                      ]),
                      _vm._v(
                        " Jeśli nie wiesz, jaka opcja byłaby dla klienta najkorzystniejsza przygotuj poniżej kilka opcji do wyboru. "
                      )
                    ]
                  )
                ],
                1
              ),
              _c(
                "v-col",
                {
                  staticClass: "pa-4",
                  staticStyle: { "text-align": "center" },
                  attrs: { cols: "2" }
                },
                [
                  _c(
                    "a",
                    {
                      on: {
                        click: function($event) {
                          _vm.isMessagesEnabled = true
                        }
                      }
                    },
                    [
                      _c("v-icon", { attrs: { size: "80" } }, [_vm._v("email")])
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        : _vm._e(),
      _vm.isMessagesEnabled || _vm.data.messages.length > 0
        ? _c("message-list", {
            staticClass: "mb-3",
            attrs: {
              "travel-service-order-id": _vm.data.id,
              "travel-service-order-item-id": _vm.data.orderItem.id,
              "start-messages": _vm.data.messages
            }
          })
        : _vm._e(),
      _c("h2", [_vm._v("Lista ofert")]),
      _c(
        "v-form",
        {
          ref: "form",
          model: {
            value: _vm.isValid,
            callback: function($$v) {
              _vm.isValid = $$v
            },
            expression: "isValid"
          }
        },
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { cols: "8" } },
                [
                  _c(
                    "v-tabs",
                    {
                      attrs: { "show-arrows": "", "slider-color": "primary" },
                      model: {
                        value: _vm.selectedTab,
                        callback: function($$v) {
                          _vm.selectedTab = $$v
                        },
                        expression: "selectedTab"
                      }
                    },
                    [
                      _vm._l(_vm.serviceOffer, function(itemServiceOffer, n) {
                        return [
                          _c(
                            "v-tab",
                            [
                              _vm._v(" Opcja " + _vm._s(n + 1) + " "),
                              !_vm.$store.state.AdminTravelService
                                .isOfferReadonly
                                ? _c(
                                    "v-tooltip",
                                    {
                                      attrs: { bottom: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function(ref) {
                                              var on = ref.on
                                              return [
                                                _c(
                                                  "v-btn",
                                                  _vm._g(
                                                    {
                                                      attrs: { icon: "" },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.duplicate(
                                                            itemServiceOffer
                                                          )
                                                        }
                                                      }
                                                    },
                                                    on
                                                  ),
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        staticClass:
                                                          "font-weight-regular",
                                                        attrs: { small: "" }
                                                      },
                                                      [_vm._v("fa-copy")]
                                                    )
                                                  ],
                                                  1
                                                )
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        true
                                      )
                                    },
                                    [_vm._v(" Zduplikuj opcję ")]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ]
                      }),
                      !_vm.$store.state.AdminTravelService.isOfferReadonly
                        ? _c(
                            "div",
                            {
                              staticClass: "v-tab",
                              attrs: { "aria-selected": "false", role: "tab" },
                              on: { click: _vm.addServiceOffer }
                            },
                            [_vm._v(" Dodaj opcję ")]
                          )
                        : _vm._e()
                    ],
                    2
                  )
                ],
                1
              ),
              _c("v-spacer"),
              _c(
                "v-col",
                { attrs: { cols: "2" } },
                [
                  !_vm.$store.state.AdminTravelService.isOfferReadonly
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "hidden-sm-and-down grey",
                          staticStyle: { width: "95%" },
                          attrs: { dark: "" },
                          on: {
                            click: function($event) {
                              return _vm.removeCurrentServiceOffer()
                            }
                          }
                        },
                        [_vm._v(" Usuń aktualną opcję ")]
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-tabs",
            {
              staticClass: "no-tabs",
              attrs: { "show-arrows": "", "slider-color": "primary" },
              model: {
                value: _vm.selectedTab,
                callback: function($$v) {
                  _vm.selectedTab = $$v
                },
                expression: "selectedTab"
              }
            },
            [
              _vm._l(_vm.serviceOffer, function(itemServiceOffer) {
                return [
                  _c(
                    "v-tab-item",
                    { staticClass: "mt-3" },
                    [
                      _c(
                        "offer-item-form",
                        {
                          attrs: {
                            "is-baggage-field-required":
                              _vm.isBaggageFieldRequired,
                            "service-offer": itemServiceOffer,
                            "remove-service-function": function() {
                              return _vm.removeServiceOffer(itemServiceOffer)
                            },
                            type: _vm.type,
                            "return-date": _vm.data.orderItem.return_date
                          },
                          on: {
                            "update:serviceOffer": function($event) {
                              itemServiceOffer = $event
                            },
                            "update:service-offer": function($event) {
                              itemServiceOffer = $event
                            }
                          }
                        },
                        [
                          _c("amount-input", {
                            attrs: {
                              model: itemServiceOffer.price,
                              rules: [_vm.isRequired],
                              label: "Cena łącznie*",
                              readonly:
                                _vm.$store.state.AdminTravelService
                                  .isOfferReadonly
                            },
                            on: {
                              "update:model": function($event) {
                                return _vm.$set(
                                  itemServiceOffer,
                                  "price",
                                  $event
                                )
                              }
                            }
                          }),
                          _c("currency-select", {
                            attrs: {
                              model: itemServiceOffer.currency,
                              rules: [_vm.isRequired],
                              label: "Waluta*",
                              readonly:
                                _vm.$store.state.AdminTravelService
                                  .isOfferReadonly
                            },
                            on: {
                              "update:model": function($event) {
                                return _vm.$set(
                                  itemServiceOffer,
                                  "currency",
                                  $event
                                )
                              }
                            }
                          }),
                          _c(
                            "fieldset",
                            { staticClass: "custom-fieldset" },
                            [
                              _c("legend", [_vm._v("Wymagane dane")]),
                              _c("v-checkbox", {
                                staticClass: "my-0 py-0",
                                attrs: {
                                  readonly:
                                    _vm.$store.state.AdminTravelService
                                      .isOfferReadonly,
                                  label: "Email"
                                },
                                model: {
                                  value: itemServiceOffer.is_email_required,
                                  callback: function($$v) {
                                    _vm.$set(
                                      itemServiceOffer,
                                      "is_email_required",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "itemServiceOffer.is_email_required"
                                }
                              }),
                              _c("v-checkbox", {
                                staticClass: "my-0 py-0",
                                attrs: {
                                  readonly:
                                    _vm.$store.state.AdminTravelService
                                      .isOfferReadonly,
                                  label: "Nr dok. toż."
                                },
                                model: {
                                  value:
                                    itemServiceOffer.is_document_number_required,
                                  callback: function($$v) {
                                    _vm.$set(
                                      itemServiceOffer,
                                      "is_document_number_required",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "itemServiceOffer.is_document_number_required"
                                }
                              }),
                              _c("v-checkbox", {
                                staticClass: "my-0 py-0",
                                attrs: {
                                  readonly:
                                    _vm.$store.state.AdminTravelService
                                      .isOfferReadonly,
                                  label: "Dok. ważny do"
                                },
                                model: {
                                  value:
                                    itemServiceOffer.is_document_expire_required,
                                  callback: function($$v) {
                                    _vm.$set(
                                      itemServiceOffer,
                                      "is_document_expire_required",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "itemServiceOffer.is_document_expire_required"
                                }
                              }),
                              _c("v-checkbox", {
                                staticClass: "my-0 py-0",
                                attrs: {
                                  readonly:
                                    _vm.$store.state.AdminTravelService
                                      .isOfferReadonly,
                                  label: "Miejsce wyst."
                                },
                                model: {
                                  value:
                                    itemServiceOffer.is_document_issue_place_required,
                                  callback: function($$v) {
                                    _vm.$set(
                                      itemServiceOffer,
                                      "is_document_issue_place_required",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "itemServiceOffer.is_document_issue_place_required"
                                }
                              }),
                              _c("v-checkbox", {
                                staticClass: "my-0 py-0",
                                attrs: {
                                  readonly:
                                    _vm.$store.state.AdminTravelService
                                      .isOfferReadonly,
                                  label: "Data ur."
                                },
                                model: {
                                  value:
                                    itemServiceOffer.is_birth_date_required,
                                  callback: function($$v) {
                                    _vm.$set(
                                      itemServiceOffer,
                                      "is_birth_date_required",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "itemServiceOffer.is_birth_date_required"
                                }
                              }),
                              _c("v-checkbox", {
                                staticClass: "my-0 py-0",
                                attrs: {
                                  readonly:
                                    _vm.$store.state.AdminTravelService
                                      .isOfferReadonly,
                                  label: "Drugie imię"
                                },
                                model: {
                                  value:
                                    itemServiceOffer.is_middle_name_required,
                                  callback: function($$v) {
                                    _vm.$set(
                                      itemServiceOffer,
                                      "is_middle_name_required",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "itemServiceOffer.is_middle_name_required"
                                }
                              }),
                              _c("v-checkbox", {
                                staticClass: "my-0 py-0",
                                attrs: {
                                  readonly:
                                    _vm.$store.state.AdminTravelService
                                      .isOfferReadonly,
                                  label: "Obywatelstwo"
                                },
                                model: {
                                  value:
                                    itemServiceOffer.is_nationality_required,
                                  callback: function($$v) {
                                    _vm.$set(
                                      itemServiceOffer,
                                      "is_nationality_required",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "itemServiceOffer.is_nationality_required"
                                }
                              }),
                              _c("v-checkbox", {
                                staticClass: "my-0 py-0",
                                attrs: {
                                  readonly:
                                    _vm.$store.state.AdminTravelService
                                      .isOfferReadonly,
                                  label: "Miejsce pobytu"
                                },
                                model: {
                                  value:
                                    itemServiceOffer.is_residence_address_required,
                                  callback: function($$v) {
                                    _vm.$set(
                                      itemServiceOffer,
                                      "is_residence_address_required",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "itemServiceOffer.is_residence_address_required"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              })
            ],
            2
          )
        ],
        1
      ),
      _vm.data.travel_service_offer_changes_behavior ===
        _vm.changeAcceptanceType.INFORM_AFTER_CHANGE &&
      !_vm.$store.state.AdminTravelService.isOfferReadonly
        ? _c(
            "v-alert",
            { attrs: { value: true, outlined: "", color: "error darken-3" } },
            [
              _vm._v(" Ten klient "),
              _c("b", [_vm._v("będzie informowany o każdej zmianie")]),
              _vm._v(
                " w ofercie po jej zapisaniu i wysłaniu. Sprawdź czy uzupełniłeś wszystkie dane i czy są one poprawne. Będziesz mógł jedynie załączyć plik z rezerwacją. "
              )
            ]
          )
        : _vm._e(),
      _vm.data.travel_service_offer_changes_behavior ===
        _vm.changeAcceptanceType.ACCEPTANCE_NEEDED &&
      !_vm.$store.state.AdminTravelService.isOfferReadonly
        ? _c(
            "v-alert",
            { attrs: { value: true, outlined: "", color: "error darken-3" } },
            [
              _vm._v(" Każda zmiana w ofercie po wybraniu przez tego klienta "),
              _c("b", [_vm._v("musi być ponownie akceptowana")]),
              _vm._v(
                ". Sprawdź czy uzupełniłeś wszystkie dane i czy są one poprawne. Będziesz mógł jedynie załączyć plik z rezerwacją. "
              )
            ]
          )
        : _vm._e(),
      _c(
        "v-card",
        { attrs: { text: "", flat: "" } },
        [
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { color: "blue darken-1", text: "" },
                  on: { click: _vm.cancel }
                },
                [_vm._v("Anuluj")]
              ),
              !_vm.$store.state.AdminTravelService.isOfferReadonly
                ? [
                    _c(
                      "v-btn",
                      {
                        attrs: {
                          disabled: _vm.$store.getters["Ajax/loading"],
                          color: "blue darken-1",
                          text: ""
                        },
                        on: { click: _vm.previewPDF }
                      },
                      [_vm._v("Podgląd PDF")]
                    ),
                    _c(
                      "v-btn",
                      {
                        attrs: {
                          disabled: _vm.$store.getters["Ajax/loading"],
                          color: "blue darken-1",
                          text: ""
                        },
                        on: { click: _vm.save }
                      },
                      [_vm._v("Zapisz i wyślij ")]
                    )
                  ]
                : _vm._e(),
              _vm.data.orderItem.status ===
              _vm.itemStatus.STATUS_CLIENT_REQUEST_BOOKING_CANCEL
                ? _c(
                    "v-btn",
                    {
                      attrs: {
                        disabled: _vm.$store.getters["Ajax/loading"],
                        color: "blue darken-1",
                        text: ""
                      },
                      on: { click: _vm.cancelledBooking }
                    },
                    [_vm._v(" Zapisz jako odwołane ")]
                  )
                : _vm._e()
            ],
            2
          )
        ],
        1
      ),
      _c("AdminOfferHistory", { attrs: { "service-offer": _vm.serviceOffer } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }